export default {
  methods: {
    limitSize(string = "", maxLength = 40) {
      return string.length > maxLength ? `${string.substring(0, maxLength - 3)}…` : string;
    }
  }
};
